import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { Spin } from 'antd';
import useDebouncedFunction from 'utils/hooks/useDebouncedFunction';
import FilterDropdown from 'components/FilterDropdown';
import { SearchInput, ListWrap } from 'components/EnumFilteredDropdown/styled';
import Checkboxes from 'components/EnumFilteredDropdown/Checkboxes';
import useProviderSpecialties from './useProviderSpecialties';
export var DEFAULT_TITLE = 'Specialty';
var ProviderSpecialtyDropdown = function (_a) {
    var defaultValue = _a.defaultValue, onSave = _a.onSave, _b = _a.dataTest, dataTest = _b === void 0 ? 'ProviderSpecialtyDropdown' : _b, requestType = _a.requestType;
    var safeDefaultValue = defaultValue ? JSON.stringify(defaultValue) : '';
    var _c = useState(), search = _c[0], setSearch = _c[1];
    var _d = useState(safeDefaultValue), value = _d[0], setValue = _d[1];
    var _e = useProviderSpecialties(search, value), items = _e.items, loading = _e.loading, uuidName = _e.uuidName, defaultTitle = _e.defaultTitle, checkedValues = _e.checkedValues, searchByUuid = _e.searchByUuid;
    var _f = useState(defaultTitle), title = _f[0], setTitle = _f[1];
    var _g = useState(Date.now()), resetKey = _g[0], setResetKey = _g[1];
    useEffect(function () {
        if (requestType && items.length) {
            var defaultOptionBasedOnRequestType = items.find(function (item) { return item.label === requestType; });
            if (defaultOptionBasedOnRequestType) {
                setTitle(defaultOptionBasedOnRequestType.label);
                setValue(defaultOptionBasedOnRequestType.value);
                onSave(defaultOptionBasedOnRequestType.value);
            }
        }
    }, [requestType, items.length]);
    useEffect(function () {
        if (value)
            searchByUuid();
        // eslint-disable-next-line
    }, [value]);
    useEffect(function () {
        if (!loading && safeDefaultValue && value) {
            setTitle(defaultTitle);
        }
        // eslint-disable-next-line
    }, [loading, safeDefaultValue, value, uuidName]);
    var onSaveTypes = function () {
        setTitle(defaultTitle);
        onSave(JSON.parse(value));
    };
    var onResetTypes = function () {
        setTitle(DEFAULT_TITLE);
        setValue('');
        setSearch(undefined);
        onSave(undefined);
        setResetKey(Date.now());
    };
    var doChangeSearch = useDebouncedFunction(setSearch, 1000);
    var onSearchChange = function (e) {
        var text = e.target.value;
        doChangeSearch(text);
    };
    var onChange = function (e) {
        var _a;
        var mergedArray = (_a = e === null || e === void 0 ? void 0 : e.map(function (item) { return JSON.parse(item); })) === null || _a === void 0 ? void 0 : _a.flat();
        setValue(JSON.stringify(mergedArray));
    };
    return (_jsx(FilterDropdown, { title: title, content: _jsx(Spin, { spinning: loading, children: _jsxs("div", { children: [_jsx(SearchInput, { placeholder: "Search", onChange: onSearchChange, allowClear: true, "data-test": "providerSpecialtySearch" }), _jsx(ListWrap, { children: _jsx(Checkboxes, { options: items, onChange: onChange, value: checkedValues }) })] }, resetKey) }), hasDefaultValue: !!safeDefaultValue, onSave: onSaveTypes, onReset: onResetTypes, dataTest: dataTest }));
};
export default ProviderSpecialtyDropdown;
